import { all, select, fork, take, put, race, takeEvery } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'react-router-redux';

import {
  TOGGLE_NAVIGATION,
  NAVIGATION_SHOW_PANEL
} from '@xanadu/ui-shared/modules/navigation/actions';

import {
  ADD_SELECTIONS_TO_MULTIPLE,
  REQUEST_SIDEBAR_UPDATE
} from '@xanadu/ui-shared/modules/multiples/actions';

import {
  updateSidebar,
  triggerUpdateSidebar,
  TRIGGER_UPDATE_SIDEBAR,
  UPDATE_SIDEBAR,
} from './actions';

import * as api from './api';

function* watchSideBarUpdate() {
  while (true) {
    const action = yield take(TRIGGER_UPDATE_SIDEBAR);
    if (action.payload) {
      yield put(updateSidebar(action.payload));
    }
  }
}

function* handleLocationChanges({ payload }) {
  const { pathname } = payload;

  const prevPath = yield select(state => state.getIn(['routing', 'prevLocation', 'pathname']));

  if (prevPath !== pathname) {
    const sidebarVisible = yield select(state => state.getIn(['local', 'sidebar', 'visible']));

    if (sidebarVisible) {
      yield put(updateSidebar({
        visible: false,
        content: null
      }));
    }
  }
}

function* watchExternalTriggers() {
  while (true) {
    const {
      overlay,
      navigation,
      navShowPanel
    } = yield race({
      navigation: take(TOGGLE_NAVIGATION),
      navShowPanel: take(NAVIGATION_SHOW_PANEL),
    });

    // TO CHECK this 1200 usage
    if (window.innerWidth < 1200) {
      if (
        (navigation && navigation.payload) ||
        (overlay) ||
        (navShowPanel && navShowPanel.payload)
      ) yield put(triggerUpdateSidebar({ visible: false }));
    }
  }
}

function* watchSideBarUpdateForScrollHandling() {
  while (true) {
    const action = yield take(UPDATE_SIDEBAR);
    if (action.payload) {
      const { visible } = action.payload;

      api.setBodyScrollOverflow(visible);
    }
  }
}

function* watchForMultipleSelectionsAddition() {
  while (true) {
    yield take(ADD_SELECTIONS_TO_MULTIPLE);

    const [content, visible] = yield select(state => [
      state.getIn(['sidebar', 'content']),
      state.getIn(['sidebar', 'visible']),
    ]);

    if (content === 'multiples' && !visible) {
      yield put(triggerUpdateSidebar({
        visible: true,
        content: 'multiples'
      }));
    }
  }
}

function* handleSidebarUpdateRequest() {
  yield put(triggerUpdateSidebar({
    visible: true,
    content: 'multiples'
  }));
}

export default function* root() {
  yield all([
    takeEvery(LOCATION_CHANGE, handleLocationChanges),
    takeEvery(REQUEST_SIDEBAR_UPDATE, handleSidebarUpdateRequest),
    fork(watchSideBarUpdate),
    fork(watchExternalTriggers),
    fork(watchForMultipleSelectionsAddition),
    fork(watchSideBarUpdateForScrollHandling),
  ]);
}
